import { useEffect, useState } from 'react';
import type { IProcess } from '../../interfaces/process';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { getServiceLabel } from '../../../../common/customControls/getServiceLabel';
import { StatusLabelStatus } from '../../../../common/enums/statusLabelStatus';
import { getDisplayName } from '../../../../common/utils/getDisplayName';
import { translateKey } from '../../../translate';
import { useAbortableFetch } from '../../../utils/hooks/useAbortableFetch';
import { ProcessContainer } from '../episodes/common';
import { ProcessItemHeader } from '../episodes/ProcessItemHeader';

interface IScheduledRequestItem {
    process: IProcess;
}

export function ScheduledRequestItem(props: IScheduledRequestItem) {
    const abortableFetch = useAbortableFetch();
    const [request, setRequest] = useState<IRequestGetOne>();

    useEffect(() => {
        loadRequest();
    }, []);

    return (
        <ProcessContainer>
            <ProcessItemHeader
                date={props.process.scheduledRequest?.scheduledFor}
                isFirstItem={false}
                isItemOpen={false}
                organizationName={props.process.requesterOrganization!.name}
                practitionerName={getDisplayName(props.process.requesterPractitioner!)}
                process={props.process}
                serviceType={props.process.serviceType}
                showProcessIcon
                showStatusLabel
                statusLabel={StatusLabelStatus.notYetSent}
                title={getTitle()}
            />
        </ProcessContainer>
    );

    function getTitle() {
        if (!request) {
            return '';
        }

        const label =
            request.customControlData.vragenlijstLabel ??
            getServiceLabel(props.process.code, 'procedure', props.process.name);

        return `${label} ${translateKey('common.postMeasurement')}`;
    }

    async function loadRequest() {
        const url = `/api/requests/${props.process.id}`;
        const result = await abortableFetch.fetchJson(url, 'GET');
        setRequest(result.json);
    }
}
